export default [
    { //书城
        path: "/book",
        name: "Book",
        meta: {
          title: "书城",
          keepAlive: true,
          auth: true,
          footer: false,
          bookFooter: true,
          home: false,
          backgroundColor: "#fff"
        },
        component: () => import("@views/book/Book.vue")
    }, {
        path: "/bookCategory/:id?",
        name: "bookCategory",
        meta: {
          title: "书城分类",
          keepAlive: true,
          footer: false,
          auth: true,
          home: false,
          bookFooter: true,
          backgroundColor: "#fff"
        },
        component: () => import("@views/book/BookCategory.vue")
      }, {
        path: "/bookType/:id?",
        name: "bookType",
        meta: {
          title: "分类书籍",
          keepAlive: true,
          footer: false,
          auth: true,
          home: false,
          bookFooter: false
        },
        component: () => import("@views/book/BookType.vue")
      }, {
        path: "/bookCart",
        name: "BookCart",
        meta: {
            title: "购物车",
            keepAlive: true,
            footer: false,
            auth: true, 
            home:false,
            bookFooter: true
        },
        component: ()=> import("@views/shop/ShoppingCart")
    }, {
        path: "/bookUser",
        name: "bookUser",
        meta: {
            title: "个人中心",
            keepAlive: true,
            footer: false,
            auth: true, 
            home: false,
            bookFooter: true
        },
        component: ()=> import("@views/user/User")
    }, {
      path: "/bookSearch",
      name: "bookSearch",
      meta: {
        title: "搜索图书",
        keepAlive: true,
        backgroundColor: "#fff",
        home: false
      },
      component: ()=> import("@views/shop/GoodSearch")
    }
];